export const iconFontAwesomeMapsMap = (
	<i className="fa-solid fa-map"></i>
);
